module.exports = __webpack_public_path__ + "img/76284.1f88606f.svg";